import React from "react"

import { Floor } from "shared/types/Floor"
import { FloorPrice } from "shared/types/__generated__/graphql"

import { FloorFormModel } from "features/floor-management/types/FloorFormModel"
import { FloorCoreHandlers } from "features/floor-management/types/FloorModel"

import { ProjectPageFloorSidebarView } from "./ProjectPageFloorSidebarView"
import { useProjectPageFloorSidebarViewModel } from "./hooks/useProjectPageFloorSidebarViewModel"

export interface ProjectPageFloorSidebarModel {
  projectID: string
  floor: Floor

  price?: FloorPrice | null | undefined
  isLoadingPrice?: boolean
  isPriceServiceAvailable?: boolean

  productTotal: number

  floorFormModel: FloorFormModel
  callbacks: FloorCoreHandlers

  isPending?: boolean
  isDisabled?: boolean

  hideControls?: boolean

  isEditing: boolean
  enterEditing: () => void
  exitEditing: () => void
  sidebarActiveTab: string | null
  setSidebarActiveTab: (tab: string | null) => void
}

export interface ProjectPageFloorSidebarProps
  extends ProjectPageFloorSidebarModel {
  id: string

  hidePrice?: boolean

  autoFocus?: boolean
}

export const ProjectPageFloorSidebar = React.memo(
  (props: ProjectPageFloorSidebarProps) => (
    <ProjectPageFloorSidebarView
      {...useProjectPageFloorSidebarViewModel(props)}
    />
  )
)
